
import { SequentialPrintLabelPolicy } from "constants/common/SequentialPrintLabelPolicy";
import { EMPTY_PRINT_QUEUE_ENTITY, PrintQueueEntity } from "domain/entity/Common/PrintQueueEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { PrintQueueRepository } from "domain/repository/Common/PrintQueue";
import _ from "lodash";
import { createPrintQueueMaintenanceValidationSchema } from "presentation/constant/PrintQueue/PrintQueueMaintenanceValidationSchema";
import { Validation } from "presentation/constant/Validation";
import { PrintQueueMaintenanceModel } from "presentation/model/PrintQueue/PrintQueueMaintenanceModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface PrintQueueMaintenanceVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<PrintQueueMaintenanceModel>> | ((value: SetStateAction<PrintQueueMaintenanceModel>) => void),
    ],
    repo: PrintQueueRepository,
}

export const PrintQueueMaintenanceVM = ({ dispatch, repo }: PrintQueueMaintenanceVMProps) => {
    const [printQueueMainDispatch] = dispatch;

    const loadDropdownOption = async () => {

    }

    const onSearch = async () => {
        printQueueMainDispatch(prevState => ({
            ...prevState,
            tableData: [],
            selectedRows: [],
            currentSelectedRow: EMPTY_PRINT_QUEUE_ENTITY,
            isBackMaster: false,
            masterState: {
                ...prevState.masterState,
                isSliderOpen: false,
            }
        }))

        let entities = await repo.getAllPrintQueues();
        const labels = SequentialPrintLabelPolicy.labels;
        let seqPrintLabel = labels.map(label => ({ ...label }));
        if (entities) {
            entities?.forEach(async (entity) => {
                const enabledSeqLabel = entity.sequentialPrintingLabel === null ? "N" : "Y";
                entity.enabledSeqLabel = enabledSeqLabel;
                if (entity.sequentialPrintingLabel) {
                    seqPrintLabel?.forEach(async (label) => {
                        if (entity.sequentialPrintingLabel === label.key) {
                            label.value = false;
                        }
                    })
                }
            })

            printQueueMainDispatch(prevState => ({
                ...prevState,
                tableData: entities,
                selectedRows: [],
                currentSelectedRow: EMPTY_PRINT_QUEUE_ENTITY,
                isBackMaster: false,
                seqPrintLabel: seqPrintLabel,
            }))
        }
    }

    const updateSelectedRows = async (selecedRows: PrintQueueEntity[]) => {
        printQueueMainDispatch(prevState => {

            return {
                ...prevState,
                selectedRows: selecedRows,
            }
        })
    }

    const onAdd = () => {
        printQueueMainDispatch(prevState => {

            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSliderOpen: true,
                    isAdd: true,
                    isEditable: false,
                    isRead: false,
                    editingEntity: EMPTY_PRINT_QUEUE_ENTITY,
                }
            }
        })
    }

    const onEdit = (currentEntity: PrintQueueEntity) => {
        printQueueMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: currentEntity,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: true,
                    isRead: false,
                    editingEntity: {
                        ...currentEntity
                    },
                }
            }
        })
    }

    const onOpenEdit = (currentEntity: PrintQueueEntity) => {
        printQueueMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: currentEntity,
                masterState: {
                    ...prevState.masterState,
                    isSliderOpen: true,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    editingEntity: {
                        ...currentEntity
                    },
                }
            }
        })
    }

    const onReset = () => {
        printQueueMainDispatch(prevState => {
            const resetEntity = prevState.masterState.isAdd ? EMPTY_PRINT_QUEUE_ENTITY : prevState.currentSelectedRow;
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingEntity: {
                        ...resetEntity
                    },
                }
            }
        })
    }

    const onClose = () => {
        printQueueMainDispatch(prevState => {
            return {
                ...prevState,
                currentSelectedRow: EMPTY_PRINT_QUEUE_ENTITY,
                selectedRows: [],
                masterState: {
                    ...prevState.masterState,
                    isSliderOpen: false,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    editingEntity: EMPTY_PRINT_QUEUE_ENTITY,
                    allFormState: {}
                },
                isBackMaster: true,
            }
        })
    }

    const onSaveClicked = () => {
        printQueueMainDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (currentEntity: PrintQueueEntity, isAdd: boolean) => {
        const valResult = await Validation(createPrintQueueMaintenanceValidationSchema).ValidateFormOnly(currentEntity);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            printQueueMainDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }

        if (isAdd) {
            return await repo.createNewPrintQueue(currentEntity);
        } else {
            return await repo.updatePrintQueue(currentEntity);
        }
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        printQueueMainDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                editingEntity: {
                    ...prevState.masterState.editingEntity,
                    [fieldName]: checked ? "Y" : "N",
                }
            }
        }))
    }

    const onFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        if (fieldKey === 'printQueueName') {
            val = val.toUpperCase().replace(/\s+/g, '');
        }

        printQueueMainDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingEntity: {
                        ...prevState.masterState.editingEntity,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: '',
                    }
                }
            }
        })
    }
    const onDateRangeChange = (startDate: any, endDate: any, dateFields: { startField: string, endField: string }) => {
        printQueueMainDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                editingEntity: {
                    ...prevState.masterState.editingEntity,
                    [dateFields.startField]: startDate,
                    [dateFields.endField]: endDate,
                },
            }
        }))
    }

    const onDelete = (data: PrintQueueEntity) => {
        printQueueMainDispatch(prevState => {
            const printQueues = prevState.tableData?.filter((print) =>
                print.printQueueName !== data.printQueueName);
            return {
                ...prevState,
                tableData: printQueues,
                selectedRows: [],
                currentSelectedRow: EMPTY_PRINT_QUEUE_ENTITY,
            };
        });

        return repo.deletePrintQueueByKey(data.id.toString());
    }


    return {
        onDateRangeChange: onDateRangeChange,
        loadDropdownOption: loadDropdownOption,
        updateSelectedRows: updateSelectedRows,
        onAdd: onAdd,
        onEdit: onEdit,
        onReset: onReset,
        onClose: onClose,
        onSearch: onSearch,
        onSaveClicked: onSaveClicked,
        onSave: onSave,
        onCheckboxChange: onCheckboxChange,
        onFieldChange: onFieldChange,
        onDelete: onDelete,
        onOpenEdit: onOpenEdit,
    }
}